export default __webpack_public_path__ + "static/purchase-bg-desktop-7040c3220922652111c9ab3bc7218432.jpg";